import { computed } from '@nuxtjs/composition-api';
import { sharedRef, useVSFContext } from '@vue-storefront/core';
import {
  CustomQuery
} from '@vue-storefront/core';
export const usePrepayDetail = (id: string): any => {
  // Loads context used to call API endpoint
  const context = useVSFContext();
  // console.log("usePreviewOrdercontext---------", context.useApiError);

  // Shared ref holding the response from the API
  const result = sharedRef(null, `usePrepayDetail-${id}`);

  // Shared ref indicating whether any method is waiting for the data from the API
  const loading = sharedRef(false, `usePrepayDetail-loading-${id}`);

  // Shared ref holding errors from the methods
  const error = sharedRef({}, `usePrepayDetail-error-${id}`);

  // Method to call an API endpoint and update `result`, `loading` and `error` properties
  const getPrePayDetail = async (params: CustomQuery) => {
    try {
      loading.value = true;
      result.value = null;
      const res = await context.$xbuy.api.prepayDetail(params);
      // context.useApiError.set(res);
      if (res && res.code === 0) {
        const data = [];
        res.data?.sub_ords?.forEach((order: any) => {
          order.order_item = order.Items;
          let order1 = JSON.parse(JSON.stringify(order));
          delete order1.Items;
          order1.cfg = (order1.cfg && order1.cfg !== '') ? JSON.parse(order1.cfg) : {};
          data.push(order1);
        });
        const preOrder = JSON.parse(JSON.stringify(res.data));
        preOrder.order_list = data;
        preOrder.sub_ords = null;
        result.value = preOrder;
        error.value.load = null;
      } else {
        error.value.load = new Error(res.message);
      }
    } catch (err) {
      error.value.load = err;
    } finally {
      loading.value = false;
    }
  };

  return {
    getPrePayDetail,
    prepayDetail: computed(() => result.value),
    loading: computed(() => loading.value),
    error: computed(() => error.value)
  };
};
